module.exports = __webpack_public_path__ + "img/concurseiro-logo.de7454df.png";